import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicOrderItemProductAttributeResponse } from './public-order-item-product-attribute.response';

@jsonObject
export class PublicOrderItemAttributeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(PublicOrderItemProductAttributeResponse)
  public readonly productAttribute!: PublicOrderItemProductAttributeResponse;
}
